import { Injectable } from '@angular/core';
import { RestApiService } from '../rest-api.service';
import { IElementsViewModel } from '../../ViewModel/ElementsModel'
import { Observable } from 'rxjs';

@Injectable()
export class ElementsService {
  private getElementListUrl = 'Elements/GetElementsList';
  private insertUpdateElementsUrl = 'Elements/InsertUpdateElementsList';

  constructor(private restAPTService: RestApiService) { }


  /**
   * Get Elements List API
   * @param de_Id 50
   */
  public GetElementsList(de_Id?: number): Observable<IElementsViewModel[]> {
    let reqData = {
      'de_Id': de_Id,
    };
    return this.restAPTService.new_POST(this.getElementListUrl, reqData);
  }

  /**
   * Insert and Update Element Details
   * @param elements 
   */
  public insertUpdateElements(elements: IElementsViewModel): Observable<any> {
    return this.restAPTService.new_POST(this.insertUpdateElementsUrl, elements);
  }

}
